<template>
  <div>
    <filters/>
    <!-- dirty trick to make sure that all products are displayed on the root path '/' -->
    <listOfProducts :products="getProducts(
      $route.path === '/' ? 'all' : $route.params.category,
      $route.path === '/' ? null : $route.params.discipline
      )"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import listOfProducts from './ListOfProducts';
import filters from './Filters';

export default {
  components: {
    listOfProducts,
    filters,
  },
  computed: {
    ...mapGetters([
      'getProducts',
    ]),
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AllProducts.vue